import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { GroupFilterOptions } from "@/_models/filters/group-filter-options";
import { RadioOption } from "@/components/shared/radio-list/radio-list.component";

@Component({
    selector: "app-promotion-insights-filter-topbar",
    templateUrl: "./promotion-insights-filter-topbar.component.html",
    styleUrls: ["./promotion-insights-filter-topbar.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromotionInsightsFilterTopbarComponent {
    @Input() filterForm: UntypedFormGroup;
    @Input() currentFilters;
    @Input() groupFilterOptions: GroupFilterOptions;
    @Input() userList: RadioOption[];
    @Output() filterButtonClicked: EventEmitter<void> =
        new EventEmitter<void>();

    openFilterMenu() {
        this.filterButtonClicked.emit();
    }

    isDisplayable(filter): boolean {
        return !!filter.value?.length;
    }

    resetFilter(filterKey: string) {
        const emptyValue = filterKey === "groups" ? [] : "";
        return this.filterForm.get(filterKey)?.setValue(emptyValue);
    }
}
